import React from "react";
import { RCCDropDownItem, RCCIcon } from "react-common-components";
import OptionsColumn from "src/components/DefaultColumnsList/Options";
import { useAuth } from "src/context/Auth/context";
import { PermissionEnum } from "src/context/Auth/interface";
import { useTranslation } from "src/context/Translations/context";
import { ActionSituationFilter } from "../../interface";
import { IOptionsOfActions } from "./interface";

/*  

######## Permissão de sistema: Visualizar ########

------ Ação Aberta ------

Alterar: (autoridade)

Copiar: (autoridade)

Add subaction: !notSubaction (autoridade)

Alterar andamento: (autoridade/responsavel)

Postergar: (autoridade/responsavel)

Cancelar: (autoridade/responsavel)

------ Ação Finalizada/Rascunho/Cancelada ------

Alterar: Rascunho (autoridade/responsave)

Copiar: (autoridade/responsavel)

Reabir: Finalizada/Cancelada (autoridade)

------ Independente ------

Visualizar: (!autoridade && !responsavel)

######## Permissão de sistema: Visualizar, Editar e Excluir ########

------ Ação Aberta/Finalizada/Rascunho/Cancelada ------

Excluir: (autoridade)    

*/  
const OptionsOfActions: React.FC<IOptionsOfActions> = ({
	positionOptions = "left",
	row,
	openModalAddOrChange,
	openModalAddSubaction,
	openModalChangeProgress,
	openModalActionPostponement,
	openModalActionCancel,
	actionButtonDelete
}) => {

	const { administrator, superUser, user, checkIfHasSpecificPermission } = useAuth();
	const { translate } = useTranslation();

	const canView = checkIfHasSpecificPermission("/actions/panel", PermissionEnum.VIEW);
	const canDelete = checkIfHasSpecificPermission("/actions/panel", PermissionEnum.CREATE_UPDATE_DELETE);

	const isAutorityOfAction = administrator || superUser || row.inb001Efa005Id2 === user.efa005Id;
	const isResponsibleOfAction = administrator || superUser || row.inb001Efa005Id === user.efa005Id;

	const actionIsOpen = (row.situation.toString() !== ActionSituationFilter.FINISHED) && (row.situation.toString() !== ActionSituationFilter.DRAFT) && (row.situation.toString() !== ActionSituationFilter.CANCELED);
	const actionIsDraft = row.situation.toString() === ActionSituationFilter.DRAFT;
	const actionIsFinishedOrCanceld = (row.situation.toString() === ActionSituationFilter.FINISHED) || (row.situation.toString() === ActionSituationFilter.CANCELED);

	if(!canView)
		return <></>;

	return (
		<OptionsColumn position={positionOptions} styleInline="margin-left: auto;">
			{isAutorityOfAction || isResponsibleOfAction ? (
				<>
					{actionIsOpen ? (
						<>
							<RCCDropDownItem
								selfEnclose
								onClick={() => openModalAddOrChange(!isAutorityOfAction)}
							>
								{isAutorityOfAction ? (
									<>
										<RCCIcon name="pencil" />
										{translate("Alterar")}
									</>
								): (
									<>
										<RCCIcon name="eye" />
										{translate("Visualizar")}
									</>
								)}
							</RCCDropDownItem>
							{isAutorityOfAction && (
								<RCCDropDownItem
									selfEnclose
									onClick={() => openModalAddOrChange(false, true)}
								>
									<>
										<RCCIcon name="copy" />
										{translate("Copiar")}
									</>
								</RCCDropDownItem>
							)}
							{!row.isSubaction && isAutorityOfAction && (
								<RCCDropDownItem
									selfEnclose
									onClick={() => openModalAddSubaction()}
								>
									<RCCIcon name="plus" />
									{translate("Adicionar")} {translate("subação")}
								</RCCDropDownItem>
							)}      
							<RCCDropDownItem
								selfEnclose
								onClick={() => openModalChangeProgress(false)}
							>
								<RCCIcon name="check" />
								{translate("Alterar andamento")}
							</RCCDropDownItem>
							<RCCDropDownItem
								selfEnclose
								onClick={() => openModalActionPostponement()}
							>
								<RCCIcon name="calendar" />
								{translate("Postergar")}
							</RCCDropDownItem>
							<RCCDropDownItem
								selfEnclose
								onClick={() => openModalActionCancel()}
							>
								<RCCIcon name="close" />
								{translate("Cancelar")}
							</RCCDropDownItem>
						</>
					) : (
						<>
							<RCCDropDownItem
								selfEnclose
								onClick={() => openModalAddOrChange(!(row.situation.toString() === ActionSituationFilter.DRAFT && isAutorityOfAction))}
							>
								{actionIsDraft && (isAutorityOfAction || isResponsibleOfAction) ? (
									<>
										<RCCIcon name="pencil" />
										{translate("Alterar")}
									</>
								): (
									<>
										<RCCIcon name="eye" />
										{translate("Visualizar")}
									</>
								)}
							</RCCDropDownItem>	
							{(isAutorityOfAction || isResponsibleOfAction) && (
								<RCCDropDownItem
									selfEnclose
									onClick={() => openModalAddOrChange(false, true)}
								>
									<>
										<RCCIcon name="copy" />
										{translate("Copiar")}
									</>
								</RCCDropDownItem>
							)}
							{actionIsFinishedOrCanceld && isAutorityOfAction && (
								<RCCDropDownItem
									selfEnclose
									onClick={() => openModalChangeProgress(true)}
								>
									<RCCIcon name="arrowBack" />
									{translate("Reabrir")}
								</RCCDropDownItem>
							)}
						</>		  
					)}

					{ (canDelete && isAutorityOfAction) && (
						<RCCDropDownItem 
							selfEnclose
							onClick={() => actionButtonDelete()}
						>
							<RCCIcon name="trash" />
							{translate("Excluir")}
						</RCCDropDownItem>
					)}

				</>
			) : (
				<RCCDropDownItem
					selfEnclose
					onClick={() => openModalAddOrChange(true)}
				>				
					<RCCIcon name="eye" />
					{translate("Visualizar")}
				</RCCDropDownItem>	
			)}
		</OptionsColumn>
	);
};

export default OptionsOfActions;
